let securityCostItemID = null;
let ownShippingStatus = null;
let currentInsaurancePrice = null;
let hasDefaultProtectionItemStatus = null;

const insuranceVariantsList = [
  { id: 45596632908017, price: 0.98 },
  { id: 45596632940785, price: 1.15 },
  { id: 45596632973553, price: 1.35 },
  { id: 45596633006321, price: 1.55 },
  { id: 45596633039089, price: 1.75 },
  { id: 45596633071857, price: 1.95 },
  { id: 45596633104625, price: 2.15 },
  { id: 45596633137393, price: 2.35 },
  { id: 45596633170161, price: 2.55 },
  { id: 45596633202929, price: 2.75 },
  { id: 45596633235697, price: 2.95 },
  { id: 45596633268465, price: 3.15 },
  { id: 45596633301233, price: 3.35 },
  { id: 45596633334001, price: 3.55 },
  { id: 45596633366769, price: 3.75 },
  { id: 45596633399537, price: 3.95 },
  { id: 45596633432305, price: 4.15 },
  { id: 45596633465073, price: 4.35 },
  { id: 45596633497841, price: 4.55 },
  { id: 45596633530609, price: 4.75 },
  { id: 45596633563377, price: 4.95 },
  { id: 45596633596145, price: 5.15 },
  { id: 45596633628913, price: 5.35 },
  { id: 45596633661681, price: 5.55 },
  { id: 45596633694449, price: 5.75 },
  { id: 45596633727217, price: 5.95 },
  { id: 45596633759985, price: 6.15 },
  { id: 45596633792753, price: 6.35 },
  { id: 45596633825521, price: 6.55 },
  { id: 45596633858289, price: 6.75 },
  { id: 45596633891057, price: 6.95 },
  { id: 45596633923825, price: 7.15 },
  { id: 45596633956593, price: 7.35 },
  { id: 45596633989361, price: 7.55 },
  { id: 45596634022129, price: 7.75 },
  { id: 45596634054897, price: 7.95 },
  { id: 45596634087665, price: 8.15 },
  { id: 45596634120433, price: 8.35 },
  { id: 45596634153201, price: 8.55 },
  { id: 45596634185969, price: 8.75 },
  { id: 45596634218737, price: 8.95 },
  { id: 45596634251505, price: 9.38 },
  { id: 45596634284273, price: 10.03 },
  { id: 45596634317041, price: 10.68 },
  { id: 45596634349809, price: 11.33 },
  { id: 45596634382577, price: 11.98 },
  { id: 45596634415345, price: 12.63 },
  { id: 45596634448113, price: 13.28 },
  { id: 45596634480881, price: 13.93 },
  { id: 45596634513649, price: 14.58 },
  { id: 45596634546417, price: 15.23 },
  { id: 45596634579185, price: 15.88 },
  { id: 45596634611953, price: 16.53 },
  { id: 45596634644721, price: 17.18 },
  { id: 45596634677489, price: 17.83 },
  { id: 45596634710257, price: 18.48 },
  { id: 45596634743025, price: 19.13 },
  { id: 45596634775793, price: 19.78 },
  { id: 45596634808561, price: 20.43 },
  { id: 45596634841329, price: 24.38 },
  { id: 45596634874097, price: 31.63 },
  { id: 45596634906865, price: 38.88 },
  { id: 45596634939633, price: 46.13 },
  { id: 45596634972401, price: 53.38 },
  { id: 45596635005169, price: 60.63 },
  { id: 45596635037937, price: 67.88 },
  { id: 45596635070705, price: 75.13 },
  { id: 45596635103473, price: 82.38 },
  { id: 45596635136241, price: 89.63 },
  { id: 45596635169009, price: 96.88 },
  { id: 45596635201777, price: 104.13 },
  { id: 45596635234545, price: 111.38 },
  { id: 45596635267313, price: 118.63 },
  { id: 45596635300081, price: 125.88 },
  { id: 45596635332849, price: 133.13 },
  { id: 45596635365617, price: 140 },
];

document.addEventListener("DOMContentLoaded", function () {
  ownShippingStatus = sessionStorage.getItem("insuranceChecked");
  hasDefaultProtectionItemStatus = sessionStorage.getItem(
    "hasDefaultProtectionItem"
  );

  if (ownShippingStatus !== null) {
    document.getElementById("addSecurityCost").checked =
      ownShippingStatus | false;
  }

  calculateSecurityCost();
});

/* cart observer */
const ajaxCart = document.getElementById("ajax-cart-count-value");
const observer = new MutationObserver((mutationsList) => {
  for (let mutation of mutationsList) {
    if (mutation.type === "childList") {
      calculateSecurityCost();
    }
  }
});
if (ajaxCart) {
  observer.observe(ajaxCart, { childList: true });
}

/* security cost observer */
const ownShippingCheckbox = document.getElementById("addSecurityCost");
if (ownShippingCheckbox) {
  ownShippingCheckbox.addEventListener("change", function (event) {
    if (event.target.checked) {
      sessionStorage.setItem("insuranceChecked", true);
      addSecurityCost(securityCostItemID);
    } else {
      sessionStorage.removeItem("insuranceChecked");
      removeSecurityCost();
    }
  });
}

function includeDefaultProtection() {
  if (hasDefaultProtectionItemStatus !== true && securityCostItemID !== null) {
    addSecurityCost(securityCostItemID);
  }
}

function verifyInsauranceInCart() {
  fetch(window.Shopify.routes.root + "cart.js")
    .then((response) => response.json())
    .then((cart) => {
      if (cart.items.length === 0) {
        sessionStorage.removeItem("insuranceChecked");
        document.getElementById("addSecurityCost").checked = false;
        sessionStorage.setItem("hasDefaultProtectionItem", false);
        return;
      }

      // Filtrar elementos que son seguros
      const insuranceItems = cart.items.filter((item) =>
        insuranceVariantsList.some((variant) => variant.id === item.id)
      );

      const insuranceItemCount = insuranceItems.length;

      hasDefaultProtectionItemStatus = sessionStorage.getItem(
        "hasDefaultProtectionItem"
      );

      switch (insuranceItemCount) {
        case 0:
          sessionStorage.removeItem("insuranceChecked");
          document.getElementById("addSecurityCost").checked = false;
          break;

        case 1:
          const displayElement = document.getElementById("oi-quote");

          const observer = new MutationObserver(() => {
            const insauranceItemPriceParsed = insuranceItems[0].price / 100;
            const displayPriceParsed = parseFloat(
              displayElement.innerText.slice(1)
            );

            if (insauranceItemPriceParsed !== displayPriceParsed) {
              removeSecurityCost();
            }

            observer.disconnect(); // Detener la observación una vez completada la validación
            sessionStorage.setItem("insuranceChecked", true);
            document.getElementById("addSecurityCost").checked = true;
          });

          observer.observe(displayElement, {
            childList: true,
            characterData: true,
            subtree: true,
          });

          break;

        default:
          sessionStorage.removeItem("insuranceChecked");
          document.getElementById("addSecurityCost").checked = false;
          break;
      }
    })
    .catch((error) => {
      console.error("Error al verificar el seguro en el carrito:", error);
    });
}

function calculateSecurityCost() {
  verifyInsauranceInCart();

  fetch(window.Shopify.routes.root + "cart.js")
    .then((response) => response.json())
    .then((cart) => {
      if (cart.items.length === 0) {
        sessionStorage.removeItem("insuranceChecked");
        return;
      } else {
        // Filtrar los ítems que no son de seguro
        const nonInsuranceItems = cart.items.filter(
          (item) =>
            !insuranceVariantsList.some((variant) => variant.id === item.id)
        );

        // Calcular el total ignorando los seguros
        const totalPrice = nonInsuranceItems.reduce(
          (acc, item) => acc + item.line_price / 100,
          0
        );

        let securityCost;

        if (totalPrice < 100) {
          securityCost = 0.98;
        } else if (totalPrice >= 100 && totalPrice < 500) {
          securityCost = totalPrice * 0.025;
        } else if (totalPrice >= 500 && totalPrice < 1000) {
          securityCost = totalPrice * 0.02;
        } else {
          securityCost = totalPrice * 0.0175;
        }

        securityCostItemID = findClosestVariant(securityCost);
        updateSecurityCostDisplay(securityCostItemID);
      }
    })
    .catch((error) => {
      console.error("Error getting cart:", error);
    });
}

function findClosestVariant(securityCost) {
  let roundedSecurityCost = parseFloat(securityCost.toFixed(2));

  let closestVariant = insuranceVariantsList[0];
  let closestDifference = Math.abs(roundedSecurityCost - closestVariant.price);

  let currentVariant;
  let VariantPrice;
  let currentDifference;

  for (let i = 1; i < insuranceVariantsList.length; i++) {
    currentVariant = insuranceVariantsList[i];
    VariantPrice = parseFloat(currentVariant.price);
    currentDifference = Math.abs(roundedSecurityCost - VariantPrice);

    if (
      currentDifference < closestDifference ||
      (currentDifference === closestDifference &&
        VariantPrice > closestVariant.price)
    ) {
      closestVariant = currentVariant;
      closestDifference = currentDifference;
    }
  }

  return closestVariant.id;
}

function addSecurityCost(securityCostItemID) {
  fetch(window.Shopify.routes.root + "cart.js")
    .then((response) => response.json())
    .then((cart) => {
      let insuranceItems = cart.items.filter((item) =>
        insuranceVariantsList.some((variant) => variant.id === item.id)
      );

      let removePromises = insuranceItems.map((item) => {
        return fetch(window.Shopify.routes.root + "cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: item.id,
            quantity: 0,
          }),
        });
      });

      Promise.all(removePromises)
        .then(() => {
          fetch(window.Shopify.routes.root + "cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              id: securityCostItemID,
              quantity: 1,
            }),
          })
            .then((response) => response.json())
            .then((data) => {
              // Actualiza el carrito
              fetch(window.Shopify.routes.root + "cart.js")
                .then((response) => response.json())
                .then((updatedCart) => {
                  sessionStorage.setItem("insuranceChecked", true);
                  sessionStorage.setItem("hasDefaultProtectionItem", true);
                  hasDefaultProtectionItemStatus = true;
                  document.getElementById("addSecurityCost").checked = true;

                  // Aquí invoca la función que refresca la UI del carrito
                  ne(updatedCart); // Asegúrate de que esta función esté disponible
                });
            })
            .catch((error) => {
              console.error("Error adding shipping insurance:", error);
            });
        })
        .catch((error) => {
          console.error("Error removing shipping insurance:", error);
        });
    })
    .catch((error) => {
      console.error("Error getting cart:", error);
    });
}

function removeSecurityCost() {
  sessionStorage.removeItem("insuranceChecked");
  document.getElementById("addSecurityCost").checked = false;

  fetch(window.Shopify.routes.root + "cart.js")
    .then((response) => response.json())
    .then((cart) => {
      let insuranceItems = cart.items.filter((item) =>
        insuranceVariantsList.some((variant) => variant.id === item.id)
      );

      let removePromises = insuranceItems.map((item) => {
        return fetch(window.Shopify.routes.root + "cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: item.id.toString(),
            quantity: 0,
          }),
        });
      });

      Promise.all(removePromises)
        .then(() => {
          // Actualiza el carrito
          fetch(window.Shopify.routes.root + "cart.js")
            .then((response) => response.json())
            .then((updatedCart) => {
              // Aquí invoca la función que refresca la UI del carrito
              ne(updatedCart); // Asegúrate de que esta función esté disponible
            });
        })
        .catch((error) => {
          console.error("Error removing shipping insurance:", error);
        });
    })
    .catch((error) => {
      console.error("Error fetching cart:", error);
    });
}

function updateSecurityCostDisplay(securityCostItemID) {
  return new Promise((resolve) => {
    const securityCostField = document.getElementById("oi-quote");
    const selectedVariant = insuranceVariantsList.find(
      (variant) => variant.id === securityCostItemID
    );

    if (!selectedVariant) {
      console.error("No se encontró el ID de variante para el seguro.");
      resolve(); // Finaliza aunque no se actualice correctamente
      return;
    }

    currentInsaurancePrice = selectedVariant.price;
    securityCostField.innerText = `$${selectedVariant.price}`;

    resolve(); // Indica que la actualización se ha completado
  });
}
